import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
  signal,
  OnInit,
  OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'so-ai-loader-ui',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './so-ai-loader.component.html',
  styleUrl: './so-ai-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoAiLoaderUI implements OnInit, OnDestroy {
  // Inputs
  size = input<number>(48);
  color = input<string>('--so-secondary');
  text = input<string>('');
  showText = input<boolean>(true);
  textPosition = input<'left' | 'right' | 'bottom'>('bottom');

  // Internal animation state
  protected animationPhase = signal<number>(0);
  private animationFrame: number | null = null;
  private startTime: number = 0;

  // Computed styles
  protected containerClasses = computed(() => ({
    'so-ai-loader': true,
    [`so-ai-loader--text-${this.textPosition()}`]: true
  }));

  protected iconSize = computed(() => `${this.size()}px`);

  protected resolvedColor = computed(() => {
    const c = this.color();
    return c.startsWith('--') ? `var(${c})` : c;
  });

  protected textStyle = computed(() => ({
    'font-size': `${Math.max(12, this.size() * 0.3)}px`
  }));

  ngOnInit(): void {
    this.startAnimation();
  }

  ngOnDestroy(): void {
    this.stopAnimation();
  }

  private startAnimation(): void {
    this.startTime = performance.now();
    const animate = (time: number) => {
      const elapsed = time - this.startTime;
      // Update phase every ~16ms for smooth 60fps animation
      this.animationPhase.set((elapsed / 1000) % 1);
      this.animationFrame = requestAnimationFrame(animate);
    };
    this.animationFrame = requestAnimationFrame(animate);
  }

  private stopAnimation(): void {
    if (this.animationFrame !== null) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }
}
